export default __webpack_public_path__ + "static/media/Nosotros_Hero1440.9d43d65a.jpg";